<div class="navbar-main">
    <fuse-navigation layout="horizontal"></fuse-navigation>
</div>